var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "cs-resolved-cards-wrap" }, [
    _c(
      "div",
      { staticClass: "cs-resolved-cards" },
      _vm._l(_vm.references, function (ref) {
        return _c(
          "div",
          {
            key: ref.id,
            staticClass: "cs-product-card",
            style: { opacity: ref._deselected ? 0.4 : 1 },
          },
          [
            _c("div", { staticClass: "cs-product-card__thumb-wrap" }, [
              _c("img", {
                staticClass: "cs-product-card__thumb",
                attrs: {
                  src: _vm.effectiveUrl(ref),
                  alt: _vm.displayName(ref),
                },
              }),
              _vm._v(" "),
              ref._processing
                ? _c("div", { staticClass: "cs-product-card__processing" }, [
                    _c("span", { staticClass: "cs-product-card__spinner" }),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "cs-product-card__processing-text" },
                      [_vm._v("Processing…")]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              !ref._processing
                ? _c(
                    "div",
                    {
                      staticClass: "cs-product-card__check",
                      class: {
                        "cs-product-card__check--deselected": ref._deselected,
                      },
                      attrs: {
                        role: "button",
                        "aria-label": ref._deselected
                          ? "Reselect this product"
                          : "Deselect this product",
                      },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.$emit(
                            "action",
                            `toggle_product_selection:${ref.id}`
                          )
                        },
                      },
                    },
                    [!ref._deselected ? _c("span", [_vm._v("✓")]) : _vm._e()]
                  )
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "cs-product-card__name" }, [
              _vm._v("\n        " + _vm._s(_vm.displayName(ref)) + "\n      "),
            ]),
          ]
        )
      }),
      0
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "cs-resolved-cards__actions" },
      [
        _c(
          "b-button",
          {
            staticClass: "cs-resolved-cards__select-btn",
            attrs: { variant: "secondary" },
            on: {
              click: function ($event) {
                return _vm.$emit("action", "select_different_product")
              },
            },
          },
          [_vm._v("\n      Select a different image\n    ")]
        ),
        _vm._v(" "),
        _vm.autoCutRefs.length > 0
          ? _c(
              "b-dropdown",
              {
                attrs: {
                  variant: "link",
                  "no-caret": "",
                  right: "",
                  "toggle-class": "cs-resolved-cards__menu-toggle",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "button-content",
                      fn: function () {
                        return [
                          _c(
                            "span",
                            {
                              staticClass: "cs-resolved-cards__dots",
                              attrs: { "aria-label": "More options" },
                            },
                            [_vm._v("⋮")]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  380195848
                ),
              },
              [
                _vm._v(" "),
                _vm.autoCutRefs.length === 1
                  ? [
                      _c("b-dropdown-header", [
                        _vm._v(_vm._s(_vm.displayName(_vm.autoCutRefs[0]))),
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.$emit(
                                "action",
                                `keep_background:${_vm.autoCutRefs[0].id}`
                              )
                            },
                          },
                        },
                        [_vm._v("\n          Keep image background\n        ")]
                      ),
                    ]
                  : _vm._l(_vm.autoCutRefs, function (ref) {
                      return _c(
                        "b-dropdown-item",
                        {
                          key: ref.id,
                          on: {
                            click: function ($event) {
                              return _vm.$emit(
                                "action",
                                `keep_background:${ref.id}`
                              )
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n          Keep background for " +
                              _vm._s(_vm.displayName(ref)) +
                              "\n        "
                          ),
                        ]
                      )
                    }),
              ],
              2
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }